import React from "react"
import Lottie from "react-lottie"

import Loader from "../assets/animations/loader.json"

const ActivityIndicator = ({ visible }) => {
  const defaultOptions = {
    loop: true,

    autoplay: true,

    animationData: Loader,

    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  }

  if (!visible) return null

  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center position-fixed opacity-25 " style={{ zIndex: 99999 }}>
      <Lottie options={defaultOptions} width={400} height={200} />
    </div>
  )
}

export default ActivityIndicator
